'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const RESTRICTED_EXTENSIONS = [
    '7z',
    'asp',
    'bak',
    'bat',
    'bin',
    'cache',
    'cfg',
    'cfm',
    'cgi',
    'conf',
    'db',
    'env',
    'exe',
    'git',
    'htaccess',
    'html',
    'inc',
    'ini',
    'js',
    'jsp',
    'log',
    'msi',
    'otf',
    'php',
    'py',
    'rar',
    'rb',
    'rvmrc',
    'sh',
    'sql',
    'subversion',
    'svn',
    'swf',
    'tar',
    'temp',
    'tf',
    'ttf',
    'tgz',
    'tmp',
    'tpl',
    'woff',
    'woff2',
    'wsdl',
    'xml',
    'yml',
    'zip'
];

exports.RESTRICTED_EXTENSIONS = RESTRICTED_EXTENSIONS;
//# sourceMappingURL=restricted-extensions.js.map
